// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"78e5ee8b","192":"bb8d6580"}[chunkId] + ".chunk.js";
};